/* unplugin-vue-components disabled */import { render } from "./LayoutFooter.vue?vue&type=template&id=1ed4f473&scoped=true"
const script = {}

import "./LayoutFooter.vue?vue&type=style&index=0&id=1ed4f473&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\zyark\\Desktop\\ems-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed4f473"]])

export default __exports__